const isValidToken = (token: string) => token.split('.').length === 3;

interface Params {
  token: string;
  runtime?: 'node' | 'web';
}

export function getUserIdFromAccessToken({
  token,
  runtime = typeof window === 'undefined' ? 'node' : 'web', // edge runtime 대응
}: Params) {
  if (!isValidToken(token)) return null;

  const [, payloadPart] = token.split('.');
  const base64DecodedPart =
    runtime === 'node' ? Buffer.from(payloadPart, 'base64').toString() : atob(payloadPart);

  try {
    return JSON.parse(base64DecodedPart)?.userId as number;
  } catch (error) {
    return null;
  }
}
